import ReactPaginate from "react-paginate";
import RightArrow from "./rightArrow";
import LeftArrow from "./leftArrow";
import { PaginationWrapper } from "./pagination.style";

export function NewPagination({
    call,
    pageCount,
    range,
    setCurrentPage,
    currentPage,
}) {
    return (
        <PaginationWrapper>
            <div>
                <ReactPaginate
                    forcePage={currentPage - 1}   // always keep UI synced
                    breakLabel="..."
                    className="pagination"
                    nextLabel={<RightArrow />}
                    previousLabel={<LeftArrow />}
                    pageClassName="page-link"
                    activeClassName="active-page-link"
                    pageRangeDisplayed={range}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    onPageChange={(e) => {
                        const selectedPage = e.selected + 1; // 1-based page
                        setCurrentPage(selectedPage);

                        if (call) {
                            call(selectedPage); // load new page
                        }
                    }}
                />
            </div>
        </PaginationWrapper>
    );
}

NewPagination.defaultProps = {
    currentPage: 1,
};
